<template lang="pug">
modal.rubrica-settings-modal(
  :close-button-label='$t("button.cancel")'
  :disable-process-button='invalidForm'
  :process-button-label='$t("button.save")'
  :title='$t("modal.rubrica_settings.title")'
  @process='process'
  ref='modal'
  size='sm'
)
  .col-12(v-if='element.recipient')
    .form-group
      label {{ $t('modal.rubrica_settings.signer') }}
      .form-control-icon
        icon(name='at')
        input.form-control(
          :placeholder='$t("modal.rubrica_settings.placeholder")'
          :value='element.recipient.addressees[0].value'
          disabled
          type='text'
        )
    .form-check.form-switch
      input#spread.form-check-input(
        @input='validate'
        type='checkbox'
        v-model='element.spread'
      )
      label.form-check-label(for='spread') {{ $t('modal.rubrica_settings.spread') }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';

export default {
  components: {
    Icon,
    Modal,
  },
  data() {
    return {
      element: {},
      invalidForm: true,
    };
  },
  methods: {
    process() {
      this.$emit('settings', this.element);
      this.$refs.modal.close();
    },
    validate() {
      this.invalidForm = false;
    },
  },
};
</script>
<style lang="stylus">
.rubrica-settings-modal
  .form-check-label
    margin: .2rem 0 0 .5rem
</style>
